export const customStyles = {
    headRow: {
      style: {
        background: "#606163",
        paddingTop: "15px",
        paddingBottom: "15px"
      },
    },
    headCells: {
      style: {
        color: "#ffffff",
        fontSize: "17px",
        fontWeight: "100",
        pointerEvents: "none"
      },
    },
  
    rows: {
      style: {
        backgroundColor: '#ffffff',
        borderBottomColor: '#ffffff',
        // outline: '1px solid #9d9fa6',
        paddingTop: "8px",
        paddingBottom: "8px"
      },
    },
    cells:{
      style:{
        color:"#7c7d7f",
        fontSize:"16px"
      }
    },
    highlightOnHoverStyle: {
      color: "#fffff",
    },
  };

  export var columnsDesktop = [
    {
      name: "TITLE",
      cell: (row: any) => row.hn_title,
      // sortable: true,
    },
    {
      name: "CREATED BY",
      selector: (row: any) => row.hn_createdByName,
      // sortable: true,
    }
  ];
  export var columnsMobile = [
    {
      name: "TITLE",
      cell: (row: any) => row.hn_title,
      // sortable: true,
    },
  ];

  